<nb-card>
  <nb-card-header>
    <h6 class="text-heading">
      {{ lecture.title }}
    </h6>

    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="details">
      <div class="description">
        {{ lecture.description }}
      </div>
    </div>

    <ngx-view-gallery
      *ngIf="lecture.sourceType == 'images' && lecture.imagesUrl.length > 0"
      [imagesUrl]="lecture.imagesUrl"
    >
    </ngx-view-gallery>

    <ngx-view-video
      *ngIf="lecture.sourceType == 'video' && lecture.videoUrl != ''"
      [url]="lecture.videoUrl"
    ></ngx-view-video>

    <ngx-view-document
      *ngIf="lecture.sourceType == 'document' && lecture.content != ''"
      [content]="lecture.content"
    >
    </ngx-view-document>
  </nb-card-body>
</nb-card>
